{
  "eyebrow": "TEAM",
  "title": "Students building for students.",
  "members": [
    { "name": "Nicholas Lee", "role": "Chief Executive Officer" },
    { "name": "Kok Hao Theng", "role": "Head of Business Development" },
    { "name": "Rolland Son", "role": "Lead Software Engineer" }
  ]
}
